/**
 * Clipping Service
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.8.25
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ClientOverviewBrandRow {
    tagId?: string;
    name?: string;
    colorCode?: string;
    brandKind?: ClientOverviewBrandRow.BrandKindEnum;
    mentions?: number;
    sharePercent?: number;
    avgReach?: number;
    avgImpact?: number;
    hasEnoughData?: boolean;
    netSentimentPercent?: number;
    positiveCount?: number;
    neutralCount?: number;
    negativeCount?: number;
    previousMentions?: number;
    previousSharePercent?: number;
    previousAvgReach?: number;
    previousAvgImpact?: number;
    hasEnoughCompareData?: boolean;
}
export namespace ClientOverviewBrandRow {
    export type BrandKindEnum = 'COMPANY' | 'COMPETITOR';
    export const BrandKindEnum = {
        COMPANY: 'COMPANY' as BrandKindEnum,
        COMPETITOR: 'COMPETITOR' as BrandKindEnum
    };
}
